import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/'
import Question from '../views/Question/'
import Risk from '../views/Risk/'
import List from '../views/List/'
import Detail from '../views/Detail/'
import wh5 from '../views/wh5/'
import Preview from '../views/Preview/'
import Order from '../views/Order/'
import editDemo from '../views/editDemo'
import softIntroduction from '../views/softIntroduction/'
import ChinaPay from '../views/ChinaPay'
import payBack from '../views/payBack'
import chooseSeat from '../views/chooseSeat'
import single from '../views/single/index.vue'
import single_add from '../views/single/singleAdd.vue'
import doc_test from '../views/doc/test.vue'
import iframePay from '../views/IframeOrder/main.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/question',
    name: 'Question',
    component: Question
  },
  {
    path: '/risk',
    name: 'Risk',
    component: Risk
  },
  {
    path: '/preview',
    name: 'Preview',
    component: Preview
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  },
  {//此路由用于，后端跳转重定向，由于后端转发的时候，必须用?id=xxx形式传参，所以前端收到之后，转到detail路由
    path: '/oldDetail',
    redirect: to=>{
        var id = to.query.id
        return { path: '/detail/'+ id, query: null }
    }
  },
  {
    path: '/ChinaPay',
    name: 'ChinaPay',
    component: ChinaPay
  },
  {
    path: '/payBack',
    name: 'payBack',
    component: payBack
  },
  {
    path: '/editDemo',
    name: 'editDemo',
    component: editDemo
  },
  {
    path: '/softIntroduction',
    name: 'softIntroduction',
    component: softIntroduction
  },
  {
    path: '/chooseSeat',
    name: 'chooseSeat',
    component: chooseSeat
  },
  {
    path: '/wh5/:account',
    name: 'wh5',
    component: wh5
  },
  {
    path: '/single',
    name: 'single',
    component: single,
    children: [
        {
            path: 'addbuy/:id',
            name: 'single_addbuy',
            component: single_add
        }
    ]
  },
  {
    path: '/iframePay/:id',
    name: 'iframePay',
    component: iframePay
  },
//   {
//     path: '/doc_test',
//     name: 'doc_test',
//     component: doc_test
//   }
  
  
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
    if (from.query.prepay) {
        to.query.prepay = from.query.prepay
    }
    next()
})

//防止重复跳转路由
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router
